// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VersionUpdateImageModal_modal_container__NU7ml {
    /* width: 1139px !important; */
    /* height: 775px; */
}

.VersionUpdateImageModal_modal_container__NU7ml .ant-modal-content {
    width: 100%;
    height: 775px;
    padding: 0 !important;
    border-radius: 20px;
    background-color: transparent;
    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */
}

.VersionUpdateImageModal_modal_container__NU7ml .ant-modal-body {
    width: 100%;
    height: 100%;
}

.VersionUpdateImageModal_main__zdBff {
    position: relative;
    width: 100%;
    height: 100%;
    /* background-color: #ccc; */
    /* background-color: #fff; */
    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */
}

.VersionUpdateImageModal_carousel_item__Itq92,
.VersionUpdateImageModal_bg_img__8dRRB {
    max-width: 1139px;
    max-height: 775px;
    border-radius: 20px;
}

.VersionUpdateImageModal_modal_container__NU7ml .ant-modal-close {
    color: #f9f9f9;
    transition: background-color 0.5s;
}

.VersionUpdateImageModal_modal_container__NU7ml .ant-modal-close:hover {
    color: #fff;
    background-color: #aaa;
}

.VersionUpdateImageModal_modal_container__NU7ml .ant-modal-close:active {
    color: #fff;
    background-color: #ddd;
}

.VersionUpdateImageModal_header__ZdyG5 {
    width: 100%;
    padding: 60px 0;
    cursor: default;
}

.VersionUpdateImageModal_header_title__eEf5X {
    width: 100%;
    height: 60px;
    text-align: center;
    font-size: 38px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #fff;
}

.VersionUpdateImageModal_section__p7iR2 {
    width: 100%;
    padding: 0 100px;
    cursor: default;
}

.VersionUpdateImageModal_section_new__2Dwae {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 26px;
    border: 1px solid #e6e6e6;
    border-radius: 100px;
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #17A8B5;
    background-color: #ffffff;
}

.VersionUpdateImageModal_section_update__mTE-Q {
    font-size: 46px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #FFFFFF;
    padding-top: 10px;
    padding-bottom: 15px;
}

.VersionUpdateImageModal_section_update_info__6SH0T {
    font-size: 18px;
    font-family: 'PingFangSCMedium';
    color: #FFFFFF;
    margin-bottom: 32px;
}

/* .content_box {
    width: 100%;
    height: 200px;
} */

.VersionUpdateImageModal_update_item__EgjHP {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 293px;
    height: 199px;
    border-radius: 12px;
    background-color: #f9f9f9;
    padding: 30px 40px;
}

.VersionUpdateImageModal_item_header__odhpL {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 36px;
}

.VersionUpdateImageModal_item_model_img__eN2-L {
    width: 36px;
    height: 36px;
    /* margin-right: 55px; */
}

.VersionUpdateImageModal_item_model_name__dAvj5 {
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #1C1F25;
}

.VersionUpdateImageModal_item_content__3SAlQ {
    width: 100%;
    height: calc(100% - 36px);
    padding-top: 15px;
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    color: #414648;
}

.VersionUpdateImageModal_footer__BIQ7\\+ {
    position: absolute;
    left: 50%;
    bottom: 50px;
    transform: translateX(-50%);
}

.VersionUpdateImageModal_done_butn_box__XaZDI {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
}

.VersionUpdateImageModal_done_butn_arrow_img__Mi7Dq {
    width: 20px;
    height: 20px;
}

.VersionUpdateImageModal_carousel_container__fmvi7 {
    height: 100%;
}

.VersionUpdateImageModal_carousel_container__fmvi7 .slick-slide {
    text-align: center;
}

/* 调整箭头位置 */
.VersionUpdateImageModal_carousel_container__fmvi7 .slick-prev,
.VersionUpdateImageModal_carousel_container__fmvi7 .slick-next {
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
}

.VersionUpdateImageModal_carousel_container__fmvi7 .slick-prev {
    left: -25px;
}

.VersionUpdateImageModal_carousel_container__fmvi7 .slick-next {
    right: -25px;
}

.VersionUpdateImageModal_carousel_container__fmvi7 .slick-dots {
    bottom: 130px;
}

.VersionUpdateImageModal_carousel_container__fmvi7 .slick-dots li button {
    border-radius: 50%; /* 使按钮变成圆形 */
    width: 10px;        /* 设置新的宽度 */
    height: 10px;       /* 设置新的高度 */
    background-color: #dcdee6;
}

.VersionUpdateImageModal_carousel_container__fmvi7 .slick-dots .slick-active button {
    background-color: #17a8b5 !important; /* 设置激活状态的颜色，您可以根据需要更改颜色 */
}

.VersionUpdateImageModal_carousel_container__fmvi7 .slick-dots li,
.VersionUpdateImageModal_carousel_container__fmvi7 .slick-dots .slick-active {
    width: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/VersionUpdateImageModal/index.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,4FAA4F;AAChG;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,4BAA4B;IAC5B,4FAA4F;AAChG;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,WAAW;AACX;;IAEI,UAAU;IACV,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB,EAAE,YAAY;IAChC,WAAW,SAAS,WAAW;IAC/B,YAAY,QAAQ,WAAW;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC,EAAE,0BAA0B;AACpE;;AAEA;;IAEI,sBAAsB;AAC1B","sourcesContent":[".modal_container {\n    /* width: 1139px !important; */\n    /* height: 775px; */\n}\n\n.modal_container :global(.ant-modal-content) {\n    width: 100%;\n    height: 775px;\n    padding: 0 !important;\n    border-radius: 20px;\n    background-color: transparent;\n    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */\n}\n\n.modal_container :global(.ant-modal-body) {\n    width: 100%;\n    height: 100%;\n}\n\n.main {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    /* background-color: #ccc; */\n    /* background-color: #fff; */\n    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */\n}\n\n.carousel_item,\n.bg_img {\n    max-width: 1139px;\n    max-height: 775px;\n    border-radius: 20px;\n}\n\n.modal_container :global(.ant-modal-close) {\n    color: #f9f9f9;\n    transition: background-color 0.5s;\n}\n\n.modal_container :global(.ant-modal-close:hover) {\n    color: #fff;\n    background-color: #aaa;\n}\n\n.modal_container :global(.ant-modal-close:active) {\n    color: #fff;\n    background-color: #ddd;\n}\n\n.header {\n    width: 100%;\n    padding: 60px 0;\n    cursor: default;\n}\n\n.header_title {\n    width: 100%;\n    height: 60px;\n    text-align: center;\n    font-size: 38px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #fff;\n}\n\n.section {\n    width: 100%;\n    padding: 0 100px;\n    cursor: default;\n}\n\n.section_new {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 62px;\n    height: 26px;\n    border: 1px solid #e6e6e6;\n    border-radius: 100px;\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #17A8B5;\n    background-color: #ffffff;\n}\n\n.section_update {\n    font-size: 46px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #FFFFFF;\n    padding-top: 10px;\n    padding-bottom: 15px;\n}\n\n.section_update_info {\n    font-size: 18px;\n    font-family: 'PingFangSCMedium';\n    color: #FFFFFF;\n    margin-bottom: 32px;\n}\n\n/* .content_box {\n    width: 100%;\n    height: 200px;\n} */\n\n.update_item {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 293px;\n    height: 199px;\n    border-radius: 12px;\n    background-color: #f9f9f9;\n    padding: 30px 40px;\n}\n\n.item_header {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n    height: 36px;\n}\n\n.item_model_img {\n    width: 36px;\n    height: 36px;\n    /* margin-right: 55px; */\n}\n\n.item_model_name {\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #1C1F25;\n}\n\n.item_content {\n    width: 100%;\n    height: calc(100% - 36px);\n    padding-top: 15px;\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    color: #414648;\n}\n\n.footer {\n    position: absolute;\n    left: 50%;\n    bottom: 50px;\n    transform: translateX(-50%);\n}\n\n.done_butn_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n}\n\n.done_butn_arrow_img {\n    width: 20px;\n    height: 20px;\n}\n\n.carousel_container {\n    height: 100%;\n}\n\n.carousel_container :global(.slick-slide) {\n    text-align: center;\n}\n\n/* 调整箭头位置 */\n.carousel_container :global(.slick-prev),\n.carousel_container :global(.slick-next) {\n    z-index: 1;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.carousel_container :global(.slick-prev) {\n    left: -25px;\n}\n\n.carousel_container :global(.slick-next) {\n    right: -25px;\n}\n\n.carousel_container :global(.slick-dots) {\n    bottom: 130px;\n}\n\n.carousel_container :global(.slick-dots li button) {\n    border-radius: 50%; /* 使按钮变成圆形 */\n    width: 10px;        /* 设置新的宽度 */\n    height: 10px;       /* 设置新的高度 */\n    background-color: #dcdee6;\n}\n\n.carousel_container :global(.slick-dots .slick-active button) {\n    background-color: #17a8b5 !important; /* 设置激活状态的颜色，您可以根据需要更改颜色 */\n}\n\n.carousel_container :global(.slick-dots li),\n.carousel_container :global(.slick-dots .slick-active) {\n    width: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `VersionUpdateImageModal_modal_container__NU7ml`,
	"main": `VersionUpdateImageModal_main__zdBff`,
	"carousel_item": `VersionUpdateImageModal_carousel_item__Itq92`,
	"bg_img": `VersionUpdateImageModal_bg_img__8dRRB`,
	"header": `VersionUpdateImageModal_header__ZdyG5`,
	"header_title": `VersionUpdateImageModal_header_title__eEf5X`,
	"section": `VersionUpdateImageModal_section__p7iR2`,
	"section_new": `VersionUpdateImageModal_section_new__2Dwae`,
	"section_update": `VersionUpdateImageModal_section_update__mTE-Q`,
	"section_update_info": `VersionUpdateImageModal_section_update_info__6SH0T`,
	"update_item": `VersionUpdateImageModal_update_item__EgjHP`,
	"item_header": `VersionUpdateImageModal_item_header__odhpL`,
	"item_model_img": `VersionUpdateImageModal_item_model_img__eN2-L`,
	"item_model_name": `VersionUpdateImageModal_item_model_name__dAvj5`,
	"item_content": `VersionUpdateImageModal_item_content__3SAlQ`,
	"footer": `VersionUpdateImageModal_footer__BIQ7+`,
	"done_butn_box": `VersionUpdateImageModal_done_butn_box__XaZDI`,
	"done_butn_arrow_img": `VersionUpdateImageModal_done_butn_arrow_img__Mi7Dq`,
	"carousel_container": `VersionUpdateImageModal_carousel_container__fmvi7`
};
export default ___CSS_LOADER_EXPORT___;
